import graphql from 'babel-plugin-relay/macro';
import {FormikHelpers} from 'formik';
import React from 'react';
import {useMutation} from 'react-relay/hooks';
import {useHistory} from 'react-router';
import ConnectionHandler from 'relay-connection-handler-plus';
import {showEventNotification} from 'src/utils/notifications';
import {withSuspense} from 'src/utils/withSuspense';

import Form from '../components/Form';
import {FormValues} from '../types';
import {createPageCreateHydrantModelMutation} from './__generated__/createPageCreateHydrantModelMutation.graphql';

function CreatePage() {
  const history = useHistory();

  const [commit, isInFlight] = useMutation<createPageCreateHydrantModelMutation>(
    createHydrantModelMutation,
  );

  return (
    <Form
      title="Create Hydrant Model"
      button="Create Hydrant Model"
      onSubmit={handleSubmit}
      isSubmitting={isInFlight}
    />
  );

  function handleSubmit(input: FormValues, formikHelpers: FormikHelpers<FormValues>) {
    commit({
      variables: {
        input: {
          name: input.name,
          familyId: input.familyId,
        },
      },
      onCompleted: payload => {
        if (payload.createHydrantModel?.errors[0] && payload.createHydrantModel?.errors[0].fields) {
          payload.createHydrantModel?.errors[0].fields.forEach(fieldError => {
            formikHelpers.setFieldError(fieldError.fieldName, fieldError.message);
          });
        }

        const entry = payload.createHydrantModel?.hydrantModel;

        if (entry) {
          showEventNotification('added', 'Model', entry.name);
          return history.push('/admin/hydrant_models');
        }
      },
      updater: store => {
        const root = store.getRoot();

        const connectionRecords = ConnectionHandler.getConnections(
          root,
          'HydrantModelsList_hydrantModels',
        );

        if (!connectionRecords) {
          return;
        }

        const payload = store.getRootField('createHydrantModel');

        if (!payload) {
          return;
        }

        const newRecord = payload.getLinkedRecord('hydrantModel');

        if (!newRecord) {
          return;
        }

        connectionRecords.forEach(connectionRecord => {
          const newEdge = ConnectionHandler.createEdge(
            store,
            connectionRecord,
            newRecord,
            'hydrantModelEdge',
          );

          ConnectionHandler.insertEdgeAfter(connectionRecord, newEdge);
        });
      },
    });
  }
}

const createHydrantModelMutation = graphql`
  mutation createPageCreateHydrantModelMutation($input: CreateHydrantModelInput!) {
    createHydrantModel(input: $input) {
      hydrantModel {
        id
        createdAt
        name
        manufacturer {
          id
          name
        }
        family {
          id
          name
        }
      }
      errors {
        code
        fields {
          fieldName
          message
        }
      }
    }
  }
`;

export default withSuspense(CreatePage);
